@use "../../../styles/Constants.scss" as Constants;
@use "../../../styles/Colors.scss" as Colors;

.container {
	display: flex;
	align-items: center;
	padding-left: 0;
}

.remove-btn-container {
	display: flex;
	justify-content: end;
}

.timezone-container {
	margin-bottom: Constants.$val-spacing-l;
}

.delete-btn {
	display: flex;
	cursor: pointer;
	color: Colors.$col-canceledRed;
	gap: Constants.$val-spacing-xs;

	& > [class^="icon-delete"], [class^="icon-close"] {
		font-size: Constants.$val-fontSizeBig;
		align-content: center;
	}
}


.addresses {
	
	&__headers {
		margin-bottom: Constants.$val-spacing-s;
	}

	&__add {
		display: flex;
	}

	&__hint {
		color: Colors.$col-greyFontLight;
		font-style: italic;
		flex: 1;
		padding-bottom: Constants.$val-spacing-s;
	}
}
